<template>
  <router-view />
</template>

<style lang="less">
@import url('~@/common/global.less');
</style>
